import { ExecutionResult } from 'react-apollo';
import { DataProxy } from 'apollo-cache';
import { DocumentNode } from 'graphql';
import { map, remove } from 'lodash';

import { SharesItem, GetSharesItemsDocument, QueryGetSharesItemsArgs } from 'api';

interface IReducer {
  cache: DataProxy;
  result: ExecutionResult['data'];
  query: DocumentNode;
  variables: QueryGetSharesItemsArgs;
}

export default (options: IReducer) => {
  const { cache, result, query, variables } = options;
  const { getSharesItems } = cache.readQuery({
    query,
    variables,
  });

  if (!getSharesItems) {
    return;
  }
  getSharesItems.count--;

  const { deleteScheduledShares } = result.data;
  const deletedIds = map(deleteScheduledShares, 'id');
  const { items_by_session } = getSharesItems;

  getSharesItems.items_by_session = items_by_session
    .map((items: SharesItem[]) => remove(items, item => !deletedIds.includes(item.id)))
    .filter((items: SharesItem[]) => items.length);

  cache.writeQuery({
    query: GetSharesItemsDocument,
    variables,
    data: {
      getSharesItems,
    },
  });
};
